module.exports = __webpack_public_path__ + "img/g-logo-big.b8d60145.png";